import React, { useState } from "react";
import { Form, FormInputProps, Icon } from "semantic-ui-react";
import styles from "./commonStyles/PasswordInput.module.css";

export interface PasswordInputProps extends FormInputProps {
    toggleTitleShow?: string;
    toggleTitleHide?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
    type: _ignoredType,
    toggleTitleShow = "Показать пароль",
    toggleTitleHide = "Скрыть пароль",
    className,
    icon,
    iconPosition,
    disabled,
    ...restProps
}) => {
    const [visible, setVisible] = useState<boolean>(false);

    const toggleVisibility = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled) {
            setVisible(prev => !prev);
        }
    };

    if (iconPosition === "left" && icon) {
        return (
            <div className={styles.leftIconWrapper}>
                <Form.Input
                    {...restProps}
                    disabled={disabled}
                    type={visible ? "text" : "password"}
                    icon={icon}
                    iconPosition={iconPosition}
                    className={className}
                />
                <Icon
                    name={visible ? "eye slash" : "eye"}
                    link={!disabled}
                    disabled={disabled}
                    className={styles.eyeIcon}
                    title={visible ? toggleTitleHide : toggleTitleShow}
                    onClick={toggleVisibility}
                    onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
                    tabIndex={-1}
                />
            </div>
        );
    }

    return (
        <Form.Input
            {...restProps}
            disabled={disabled}
            type={visible ? "text" : "password"}
            className={className}
            icon={
                <Icon
                    name={visible ? "eye slash" : "eye"}
                    link={!disabled}
                    disabled={disabled}
                    title={visible ? toggleTitleHide : toggleTitleShow}
                    onClick={toggleVisibility}
                    onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
                    tabIndex={-1}
                />
            }
        />
    );
};

export default PasswordInput;
